import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 33, 45, 0.95);
  backdrop-filter: blur(15px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 1rem;
`;

export const ModalContent = styled.div`
  background: linear-gradient(135deg, #00212d 0%, #006693 50%, #00b056 100%);
  border: 2px solid #00b056;
  border-radius: 20px;
  padding: 2.5rem;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 80px rgba(0, 33, 45, 0.6);
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 176, 86, 0.2);
  border: 2px solid #00b056;
  color: #dbfb8e;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: bold;
  transition: all 0.3s ease;

  &:hover {
    background: #00b056;
    color: #00212d;
    transform: scale(1.1);
  }
`;

export const ModalTitle = styled.h2`
  color: #dbfb8e;
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 600;
  text-shadow: 2px 2px 4px rgba(0, 33, 45, 0.5);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  color: #00b056;
  font-weight: 600;
  font-size: 1rem;
  text-shadow: 1px 1px 2px rgba(0, 33, 45, 0.5);
`;

export const Input = styled.input`
  background: rgba(0, 33, 45, 0.4);
  border: 2px solid rgba(0, 176, 86, 0.3);
  border-radius: 12px;
  padding: 1rem;
  color: #dbfb8e;
  font-size: 1rem;
  transition: all 0.3s ease;
  outline: none;

  &::placeholder {
    color: rgba(219, 251, 142, 0.5);
  }

  &:focus {
    border-color: #00b056;
    box-shadow: 0 0 0 3px rgba(0, 176, 86, 0.2);
    background: rgba(0, 33, 45, 0.6);
  }

  &:disabled {
    background: rgba(0, 33, 45, 0.2);
    color: rgba(219, 251, 142, 0.6);
    cursor: not-allowed;
  }

  &.error {
    border-color: #ff6b6b;
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
  }
`;

export const Select = styled.select`
  background: rgba(0, 33, 45, 0.4);
  border: 2px solid rgba(0, 176, 86, 0.3);
  border-radius: 12px;
  padding: 1rem;
  color: #dbfb8e;
  font-size: 1rem;
  transition: all 0.3s ease;
  outline: none;
  cursor: pointer;

  option {
    background: #00212d;
    color: #dbfb8e;
    padding: 0.5rem;
  }

  &:focus {
    border-color: #00b056;
    box-shadow: 0 0 0 3px rgba(0, 176, 86, 0.2);
    background: rgba(0, 33, 45, 0.6);
  }

  &:disabled {
    background: rgba(0, 33, 45, 0.2);
    color: rgba(219, 251, 142, 0.6);
    cursor: not-allowed;
  }

  &.error {
    border-color: #ff6b6b;
    box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2);
  }
`;

export const PackageInfo = styled.div`
  background: rgba(0, 176, 86, 0.15);
  border: 2px solid #00b056;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const PackageName = styled.div`
  color: #00b056;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
`;

export const PackageLabel = styled.div`
  color: #dbfb8e;
  font-size: 0.9rem;
  opacity: 0.9;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(45deg, #00b056, #006693);
  color: #dbfb8e;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 8px 25px rgba(0, 176, 86, 0.3);

  &:hover {
    background: linear-gradient(45deg, #006693, #00b056);
    transform: translateY(-2px);
    box-shadow: 0 12px 35px rgba(0, 176, 86, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: rgba(0, 176, 86, 0.3);
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled.button`
  background: rgba(255, 107, 107, 0.2);
  color: #ff6b6b;
  border: 2px solid #ff6b6b;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    background: rgba(255, 107, 107, 0.3);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SuccessMessage = styled.div`
  color: #00b056;
  text-align: center;
  padding: 1rem;
  background: rgba(0, 176, 86, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(0, 176, 86, 0.3);
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const ErrorMessage = styled.div`
  color: #ff6b6b;
  text-align: center;
  padding: 1rem;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(255, 107, 107, 0.3);
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const FieldError = styled.div`
  color: #ff6b6b;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(0, 33, 45, 0.5);
`;
